import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import FullscreenDialog from "@/components/FullscreenDialog.vue";
import UserDepartment from "./department/UserDepartment.vue";
import UserMasterWorkSchedule from "./work-schedule/UserMasterWorkSchedule.vue";
import UserInfoRegist from "./info/UserInfoRegist.vue";

type Props = {
  value: boolean;
  userId?: number;
};
type Emits = {
  (e: "input", value: boolean): void;
  (e: "regist"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserMasterRegist',
  props: {
    value: { type: Boolean },
    userId: null
  },
  emits: ["input", "regist"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: boolean): void;
  (e: "regist"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  userId?: number;
};

const e1 = ref(0);
const userId = ref<number>();




const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

watch(modelValue, val => {
  if (val) {
    e1.value = 0;
    userId.value = undefined;
  }
});

const onRegist = (val: number) => {
  e1.value++;
  userId.value = val;
};

const onClose = () => {
  modelValue.value = false;
  emits("regist");
};

return { __sfc: true,e1, userId, props, emits, modelValue, onRegist, onClose, FullscreenDialog, UserDepartment, UserMasterWorkSchedule, UserInfoRegist }
}

})